import { eAtlas, Game } from "../../../Game";
import { AtlasAnimClipData } from "../../../Utils/Atlas/AtlasAnimClip";
import { WrappedArray } from "../../../Utils/Collections/WrapperArray";
import { AnimMessage1 } from "./AnimMessage1";
import { AnimMessage2 } from "./AnimMessage2";
import { IAnimMessage } from "./AnimMessageBase";
import { AnimMessageBgFx } from "./AnimMessageBgFx";



export const enum eAnimMsgBgFx {
    fireball,
    success,
    failure
}


interface AnimMsgBgFxData {
    /**
     * Horizontalni roztazeni 1 = cela sirka obrazovku, 0.5 = polovina sirky obrazovky, ...
     */
    hScale: number;
    /**
     * Data pro animacni klip
     */
    animClipData: AtlasAnimClipData;
}



interface AnimMessageData {
    y: number;
    bgFxAnim: eAnimMsgBgFx;
    textData: AtlasAnimClipData | ISlideMessageData;
}



export interface ISlideMessageData {
    atlas: pc.TextureAtlas,
    frameKey: string
}



export class AnimMessageManager {
    private _bgFxData: AnimMsgBgFxData[];

    private _msgBgFx: AnimMessageBgFx;
    private _msgText: IAnimMessage[];
    private _curMsgText: IAnimMessage;

    private _waitingMessages: WrappedArray<AnimMessageData>;

    private _actFlags: number;

    /**
     * (RO) True, pokud probiha zobrazeni zpravy
     */
    get isActive(): boolean { return this._actFlags != 0; }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        // Data pro efekty v pozadi
        this._bgFxData = [
            {
                hScale: 0.9,
                animClipData: new AtlasAnimClipData(Game.getAtlas(eAtlas.fx1), "fireball/", 25, 0, 24),
            },
            {
                hScale: 0.9,
                animClipData: new AtlasAnimClipData(Game.getAtlas(eAtlas.fx1), "0/", 25, 0, 19)
            },
            {
                hScale: 0.9,
                animClipData: new AtlasAnimClipData(Game.getAtlas(eAtlas.fx1), "2/", 25, 0, 26)
            }
        ];

        // Efekt v pozadi za textem
        this._msgBgFx = new AnimMessageBgFx(screen);

        // Animace textu
        this._msgText = [
            new AnimMessage1(screen),
            new AnimMessage2(screen)
        ];

        // Seznam cekajicich zprav
        this._waitingMessages = new WrappedArray<AnimMessageData>();
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    reset(): void {
        if (this._curMsgText) {
            this._curMsgText.reset();
            this._curMsgText = undefined;
        }

        this._msgBgFx.reset();
        this._waitingMessages.clear(true);
        this._actFlags = 0;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    showMessage(y: number, bgFxAnim: eAnimMsgBgFx, textData: AtlasAnimClipData | ISlideMessageData): void {
        if (this._actFlags != 0) {
            // Ulozit zpravu do seznamu cekajicich
            this._waitingMessages.add({
                y: y,
                bgFxAnim: bgFxAnim,
                textData: textData
            });

            return;
        }

        this._showMessage(y, bgFxAnim, textData);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    update(): void {
        if (this._actFlags == 0) {
            if (this._waitingMessages.empty)
                return;

            // Zobrazit cekajici zpravu
            let data = this._waitingMessages.remove(false);

            this._showMessage(data.y, data.bgFxAnim, data.textData);
        }

        // Efekt v pozadi
        if ((this._actFlags & 1) != 0) {
            if (!this._msgBgFx.update())
                this._actFlags &= ~1;
        }

        // Text
        if ((this._actFlags & 2) != 0) {
            if (!this._curMsgText.update()) {
                this._actFlags &= ~2;
            }
        }
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    private _showMessage(y: number, bgFxAnim: eAnimMsgBgFx, textData: AtlasAnimClipData | ISlideMessageData): void {
        // Efekt za textem
        let bgFxData = this._bgFxData[bgFxAnim];

        this._msgBgFx.play(y, bgFxData.hScale, bgFxData.animClipData);

        // Text
        if (textData instanceof AtlasAnimClipData) {
            this._curMsgText = this._msgText[0];
            (this._curMsgText as AnimMessage1).play(y, textData);
        }
        else {
            this._curMsgText = this._msgText[1];
            (this._curMsgText as AnimMessage2).play(textData.atlas, textData.frameKey, y);
        }

        this._actFlags = 3;
    }
}